import { CompanyCostCenter } from './company';

export class Environment {
    id: number;
    name: string;
    description: string;
    type: string;
    status: string;
    active: boolean;
    parent: Environment;
    companyCostCenter: CompanyCostCenter;
    color: string;
}

export class EnvironmentTO {
    id: number;
    name: string;
    color: string;
    type: string;
    status: string;
    active: boolean;
}
